// Initial pre-order date set to November 10, 2026 (month index 10 = November)
const INITIAL_PREORDER_DATE = new Date(2026, 10, 10);

export function getNextPreOrderDate(now = new Date()) {
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const nextDate = new Date(INITIAL_PREORDER_DATE);

  while (nextDate < today) {
    nextDate.setMonth(nextDate.getMonth() + 1);
  }

  return nextDate;
}

export function formatPreOrderDate(date) {
  return date.toLocaleDateString('en-US', {
    month: 'long',
    year: 'numeric',
  });
}